export default __webpack_public_path__ + "static/media/rafa9.cb7b8248.jpg";